import React from 'react';
import { useForm } from 'react-hook-form';

import { useStateMachine } from 'little-state-machine';
import { updateAction } from '../MultipartForm/stateMachineActions';

import FormStepWrapper from './FormStepWrapper';
import { MPFStepProps } from '../../util/types';
import TextArea from '../MultipartForm/Fields/TextArea';
import generateMaxLengthValidateFn from '../MultipartForm/generateMaxLengthValidateFn';

// TODO: put 90% of this into a super class or interface or something
const Step3 = (props: MPFStepProps) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { actions, state } = useStateMachine({ updateAction });
  const onSubmit = (data: any) => {
    // data.step = 1;
    actions.updateAction({
      formData: data,
    });
    props.next();
    // props.history.push('./step2');
  };
  const onBack = (e: React.MouseEvent) => {
    e.preventDefault();
    props.prev();
  };

  const content = (
    <>
      <h3 className="Form__heading">Your creative idea:</h3>
      <TextArea
        name="idea"
        label="What's your creative idea?"
        validationObj={{
          required: 'This field is required',
          validate: {
            maxLength: generateMaxLengthValidateFn(1000),
          }
        }}
        formData={state.formData}
        showEditBtn={props.reviewMode ? true : false}
        editable={props.reviewMode ? false : true}
        register={register}
        errors={errors}
        returnToStep={props.returnToStep}
      />
      <TextArea
        name="problemToSolve"
        label="What problem are you trying to solve?"
        validationObj={{
          required: 'This field is required',
          validate: {
            maxLength: generateMaxLengthValidateFn(1000),
          }
        }}
        formData={state.formData}
        showEditBtn={props.reviewMode ? true : false}
        editable={props.reviewMode ? false : true}
        register={register}
        errors={errors}
        returnToStep={props.returnToStep}
      />
      <TextArea
        name="ideaOrigin"
        label="How did you develop this idea?"
        validationObj={{
          required: 'This field is required',
          validate: {
            maxLength: generateMaxLengthValidateFn(1000),
          }
        }}
        formData={state.formData}
        showEditBtn={props.reviewMode ? true : false}
        editable={props.reviewMode ? false : true}
        register={register}
        errors={errors}
        returnToStep={props.returnToStep}
      />
      <TextArea
        name="requestAmount"
        label="How much are you requesting?"
        disclaimer={<p className="TextArea__disclaimer">
          { state.formData?.['applyingAs'] === 'group'
          ? 'A group can request up to $1000.'
          : 'Individuals can request up to $500'}
          </p>}
        validationObj={{
          required: 'This field is required',
          validate: {
            maxLength: generateMaxLengthValidateFn(1000),
          }
        }}
        formData={state.formData}
        showEditBtn={props.reviewMode ? true : false}
        editable={props.reviewMode ? false : true}
        register={register}
        errors={errors}
        returnToStep={props.returnToStep}
      />
      <TextArea
        name="howWillUseMoney"
        label="How will you use the money?"
        disclaimer={<p className="TextArea__disclaimer">Please list each expense and how much it would cost (the total of these expenses should equal the amount you are asking for).</p>}
        validationObj={{
          required: 'This field is required',
          validate: {
            maxLength: generateMaxLengthValidateFn(1000),
          }
        }}
        formData={state.formData}
        showEditBtn={props.reviewMode ? true : false}
        editable={props.reviewMode ? false : true}
        register={register}
        errors={errors}
        returnToStep={props.returnToStep}
      />
      <TextArea
        name="expectedChallenges"
        label="What challenges do you think you'll face and how will you address them?"
        validationObj={{
          required: 'This field is required',
          validate: {
            maxLength: generateMaxLengthValidateFn(1000),
          }
        }}
        formData={state.formData}
        showEditBtn={props.reviewMode ? true : false}
        editable={props.reviewMode ? false : true}
        register={register}
        errors={errors}
        returnToStep={props.returnToStep}
      />
      <TextArea
        name="expectToLearn"
        label="What do you expect to learn?"
        validationObj={{
          required: 'This field is required',
          validate: {
            maxLength: generateMaxLengthValidateFn(1000),
          }
        }}
        formData={state.formData}
        showEditBtn={props.reviewMode ? true : false}
        editable={props.reviewMode ? false : true}
        register={register}
        errors={errors}
        returnToStep={props.returnToStep}
      />
      <TextArea
        name="otherSupport"
        label="How [else] can we support?"
        validationObj={{
          validate: {
            maxLength: generateMaxLengthValidateFn(1000),
          }
        }}
        disclaimer={<p className="TextArea__disclaimer">If there are any areas where you feel you could use advice or mentorship, we may be able to connect you to resources in our community.</p>}
        formData={state.formData}
        showEditBtn={props.reviewMode ? true : false}
        editable={props.reviewMode ? false : true}
        register={register}
        errors={errors}
        returnToStep={props.returnToStep}
      />

      { props.reviewMode ? undefined :
      <div className="bottom-buttons">
        <button onClick={onBack} className="btn btn--back">Back</button>
        <input type='submit' value="Next" />
      </div>
      }
    </>
  );

  // Wrap in form if not in review mode
  return (
    props.reviewMode
    ? content
    : <FormStepWrapper onSubmit={handleSubmit(onSubmit)} content={content} />
  );
};

export default Step3;
